import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminSkillGridsRoutes: RouteObject[] = [
  {
    path: 'admin/skill-grids',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_GRIDS, title: 'Grilles d’évaluation' },
  },
  {
    path: 'admin/skill-grids/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_GRID_FORM, title: 'Nouvelle grille d’évaluation' },
  },
  {
    path: 'admin/skill-grids/:skillGridId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_GRID_FORM, title: 'Modifier la grille d’évaluation' },
  },
];
